import { reactify } from '@zeiss/zui-react';
export const ZuiIconMediaVideoJumpToNextPhase = reactify('zui-icon-media-video-jump-to-next-phase');
